<template>
  <v-dialog
    v-model="dialog"
    :width="env.mode === 'STAFF' ? 'calc(100% - 48px)' : undefined"
    :max-width="env.mode === 'STAFF' ? undefined : 1400"
  >
    <template #activator="{ props: activatorProps }">
      <slot name="customActivator" v-bind="activatorProps">
        <v-btn
          v-bind="activatorProps"
          color="primary"
          rounded="xl"
          density="comfortable"
          icon="mdi-plus"
        />
      </slot>
    </template>
    <StaffOrderShop
      v-if="dialog && env.mode === 'STAFF'"
      :person-id="person?.personId ?? undefined"
      :item-type="props.itemType"
      :membership-id="props.membershipId"
      :balance-number="props.balanceNumber"
      @complete="emit('complete')"
      @close="dialog = false"
    />
    <MemberCatalogOrderPicker
      v-else-if="dialog"
      :title="props.title || 'Shop'"
      :item-type="props.itemType"
      :membership-id="props.membershipId"
      :restock-balance-type="props.restockBalanceType"
      :balance-number="props.balanceNumber"
      @close="dialog = false"
    />
  </v-dialog>
</template>

<script setup lang="ts">
import type { Ref } from "vue";
import type { PersonStaff as Person } from "../../../cbi-generator/generated/dto/PersonStaff";
import { useEnv } from "@/composables/useEnv";
import type { ItemType } from "../../../cbi-generator/generated/dto/ItemType";
import type { BalanceType } from "../../../cbi-generator/generated/dto/BalanceType";
import StaffOrderShop from "./StaffOrderShop.vue";
import MemberCatalogOrderPicker from "./MemberCatalogOrderPicker.vue";

const props = defineProps<{
  title?: string;
  viewMaxWidth?: number;
  scrollY?: boolean;
  externalTrigger?: number;
  itemType?: ItemType;
  membershipId?: number;
  balanceNumber?: string;
  /** Member restock: only an amount is asked for, then it goes straight to the cart. */
  restockBalanceType?: BalanceType;
}>();
const emit = defineEmits<{ complete: [] }>();
const dialog = ref(false);
const env = useEnv();
const person = inject<Ref<Person | null> | undefined>("person", undefined);

watch(
  () => props.externalTrigger,
  (trigger, previous) => {
    if (trigger != null && trigger !== previous) dialog.value = true;
  },
);
</script>
